import { ElasticSearchResponse } from '../../../../../apps/app/src/modules/search/types';
import { DateTimeStr } from '../../types';
import { BaseAPIClient } from '../base-api-client';

export const TranscriptionAPI = {
  /** Simple elastic transcription search grouped by length buckets. */
  fetchSearch(
    this: BaseAPIClient,
    station: string,
    from: DateTimeStr,
    to: DateTimeStr,
    query: string,
  ): Promise<ElasticSearchResponse[]> {
    return this.get(
      `/stations/${station}/transcription/simple-search?query=${query}&from=${from}&to=${to}&groupByLength=60`,
    );
  },
};
